/**
 * phase-profile-contact-rows — the field-usage context lives in its own module
 * so the component files only export components (React Fast Refresh rule).
 */
import { createContext } from 'react';
import type { CompanyProfileFieldUsageMap } from '@/api/v2Client';

// phase-ui-company-profiles-improvements (Item 4) — the modal fetches the
// derived usage map once and provides it; each Field with a `column` renders an
// ⓘ listing the real consumers. Derived server-side — no hand-maintained list.
export const FieldUsageContext = createContext<CompanyProfileFieldUsageMap | null>(null);
